<template>
  <div class="sort-by relative inline-block">
    <button
      type="button"
      class="button small flex items-center"
      @click.stop="toggleOpen"
    >
      Sort by: {{ selectedLabel }}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4 ml-2"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>

    <div v-if="open" class="sort-by-panel" @click.stop>
      <p class="mb-2 font-bold">Sort by</p>
      <drop-down
        :options="options"
        :value="selectedOption"
        value-property="label"
        placeholder="Article name"
        @input="onFieldSelected"
      />

      <p class="mt-4 mb-2 font-bold">Direction</p>
      <div class="flex">
        <button
          type="button"
          class="button small mr-2"
          :class="{ primary: direction === ascending }"
          @click="setDirection(ascending)"
        >
          Ascending
        </button>
        <button
          type="button"
          class="button small"
          :class="{ primary: direction === descending }"
          @click="setDirection(descending)"
        >
          Descending
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from "./forms/DropDown.vue";
import {
  ARTICLE_NAME_SORT_KEY,
  SORT_ASCENDING,
  SORT_DESCENDING,
} from "../utils/articleSortHelper";

export default {
  name: "ArticleSortBy",
  components: {
    DropDown,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    // { sortKey, direction } - v-model compatible
    value: {
      type: Object,
      default: () => ({ sortKey: ARTICLE_NAME_SORT_KEY, direction: SORT_ASCENDING }),
    },
  },
  data() {
    return {
      open: false,
      ascending: SORT_ASCENDING,
      descending: SORT_DESCENDING,
    };
  },
  computed: {
    sortKey() {
      return (this.value && this.value.sortKey) || ARTICLE_NAME_SORT_KEY;
    },
    direction() {
      return (this.value && this.value.direction) || SORT_ASCENDING;
    },
    selectedOption() {
      return this.options.find(option => option.key === this.sortKey) || null;
    },
    selectedLabel() {
      return this.selectedOption ? this.selectedOption.label : "Article name";
    },
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
    onFieldSelected(option) {
      if (!option || !option.key) return;
      this.emitChange({ sortKey: option.key, direction: this.direction });
    },
    setDirection(direction) {
      this.emitChange({ sortKey: this.sortKey, direction });
    },
    emitChange(payload) {
      this.$emit("input", payload);
    },
    handleClickOutside(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.open = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.sort-by-panel {
  position: absolute;
  z-index: 20;
  margin-top: 0.5rem;
  padding: 1rem;
  width: 16rem;
  border-radius: 0.25rem;
  border: 1px solid theme("colors.primary-dark");
  background-color: theme("colors.primary");
}
</style>
